import React, {useState} from 'react'
import Modal from 'react-bootstrap/Modal';
import FabricEdit from './FabricEdit'
import { apiPut } from '../../api'

const Fabrics = props => {

    const [show, setShow] = useState(false);
    const [fabricShow, setFabricShow] = useState(false)

    const handleClose = () => {
        setShow(false)
    }

    const handleShow = () => {
        setShow(true)
    }

    const handleShowFabric = () => {
        setFabricShow(true)
    }

    const handleCloseFabric = () => {
        setFabricShow(false)
    }

    const confirmDelete = () => {
        if (window.confirm('Definitely delete?')) {
            props.handleDeleteFabric(props.fabricData.id)
        }
    }

    const handleUpdateFabric = (updateData) => {
        return apiPut(`${props.baseUrl}/fabrics/${updateData.id}`, updateData, 'Unable to update fabric')
        .then(updatedFabric => {
            props.fetchFabric()
            handleClose()
        }).catch(err=>console.log(err))
    }


    const useStyle = {
        backgroundImage: `url(${props.fabricData.picture})`,
        backgroundSize: 'contain'
    }

    return (
        <React.Fragment>
            <div className="fabric-box">
                <img src={props.fabricData.picture} className="fabric-pic" alt="fabric" onClick={handleShowFabric}/>

                <>
                <Modal show={fabricShow} onHide={handleCloseFabric} style={ {backgroundColor: 'rgb(255, 255, 255, .5)'}}>
                    <Modal.Body>
                        <img src={props.fabricData.picture} className='show-fabric' alt='fabric'/>
                    </Modal.Body>
                </Modal>
                </>

            <div className='fabric-length'>{props.fabricData.length} yards</div>
            <div className='fabric-data'>
                {props.fabricData.tags?<div className='fabric-tags' onClick={() => {
                    props.setFabricTagFilter(props.fabricData.tags)
                }}>{props.fabricData.tags}</div>:<div></div>}

                <>
                <Modal show={show} onHide={handleClose} style={ {backgroundColor: 'rgb(255, 255, 255, .5)'}}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Fabric</Modal.Title>
                    </Modal.Header>
                    <Modal.Body  style={useStyle}>

                        <FabricEdit fabricData={props.fabricData} handleUpdateFabric={handleUpdateFabric} handleClose={handleClose}/>
                    </Modal.Body>
                </Modal>
                </>

            <div className='fabric-buttons'>
                <button type="button" onClick={handleShow}>
                    <span className="lnr lnr-pencil"></span>
                </button>
                <button type="button" onClick={confirmDelete}><span className="lnr lnr-trash"></span></button>
                </div>
            </div>
        </div>
    </React.Fragment>
)
}

export default Fabrics
